import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { Tournament } from 'functions/src/types/firestore/Game/Tournament';
import dynamic from 'next/dynamic';
import { useMobile } from 'src/hooks/useMobile';
import { formatDateTime } from 'src/util/Dates';
import { Link } from '../Link';
import { LiveBadge } from '../LiveBadge';
import { NUMERIC } from 'src/util/dates/presets/dates';
const Countdown = dynamic(
  () => {
    return import('react-countdown');
  },
  {
    ssr: true,
  },
);

function Counter({ counter }: { counter: number }) {
  return (
    <Stack justifyContent="center" sx={{ mt: '-2px' }}>
      <Typography variant="subtitle1" color={'text.secondary'}>
        {counter.toString().padStart(2, '0')}
      </Typography>
    </Stack>
  );
}

export type TimeStatusProps = Required<
  Pick<Tournament<Date>, 'phase' | 'date' | 'endDate' | 'readyTime'>
> & { liveUrl: string };

export function TimeStatus(props: TimeStatusProps) {
  const { phase, date, liveUrl, endDate, readyTime } = props;
  const isMobile = useMobile();

  const endCheckInFormatted = formatDateTime(readyTime, {
    dateFormat: NUMERIC,
    separator: ', ',
  });
  const endDateFormatted = formatDateTime(endDate, {
    dateFormat: NUMERIC,
    separator: ', ',
  });
  return (
    <Box sx={{ pr: 4 }}>
      {phase === 'live' ? (
        <Box>
          <Link href={liveUrl}>
            <LiveBadge />
          </Link>
        </Box>
      ) : (
        <Stack direction="row">
          {!isMobile && (
            <Typography
              variant="subtitle1"
              sx={{
                color: 'text.secondary',
                opacity: '80%',
                fontStyle: 'italic',
                paddingRight: '8px',
              }}
            >
              {phase === 'ready'
                ? 'Starts in'
                : phase === 'finished'
                ? 'Ended on'
                : 'Check-in by'}
            </Typography>
          )}
          <Typography
            variant="subtitle1"
            sx={{
              color: 'text.secondary',
            }}
          >
            {phase === 'ready' ? (
              <Box sx={{ display: 'flex', mt: '2px' }}>
                <Countdown
                  date={date}
                  renderer={({ minutes, seconds }) => {
                    return (
                      <>
                        <Counter counter={minutes} />
                        <Typography
                          color="text.secondary"
                          variant="subtitle1"
                          sx={{ mt: '-3px' }}
                        >
                          :
                        </Typography>
                        <Counter counter={seconds} />
                      </>
                    );
                  }}
                />
              </Box>
            ) : phase === 'finished' ? (
              endDateFormatted
            ) : (
              endCheckInFormatted
            )}
          </Typography>
        </Stack>
      )}
    </Box>
  );
}
